import type { FetchState } from '../middleware';
import type { SessionsPOSTResponse } from '@api';

// The property name is not JWT like url param, jwtToken is returned in backend see JWT used in angular portal.
// @see https://bitbucket.org/mathletics/3p-portal/src/3f7324219479dd2b1091943c2143ead1d3ba4a74/route/route.js?at=develop#lines-20
export type AuthData = {
    jwtToken?: string
    token?: string
    createdAt?: string
    timeOut?: string
};

export type AuthState = FetchState<AuthData>;

/**
 * All of the supported url search param properties for this application.
 */
export enum AppURLSearchParams {
    env = 'env',
    password = 'password',
    username = 'username',
    token = 'token',
    // note the property name for the JSON web token in the Sessions api response
    // is "jwtToken" not "JWT". Angular portal already has support for "JWT" in the url params.
    jwtToken = 'JWT',
    locale = 'locale',
    lang = 'lang',
    essentialsRedirect = 'logout_return_to'
}

// Eg from the url params ?token={xxxx}
export type LegacyTokenParam = {
    [AppURLSearchParams.token]: string
};

// Eg from the url params ?JWT={xxxx}
export type JWTTokenParam = {
    [AppURLSearchParams.jwtToken]: string
};

export type LoginCredentialParams = {
    [AppURLSearchParams.username]: string
    [AppURLSearchParams.password]: string
    [AppURLSearchParams.env]?: string
};

export type Credentials =
    & LegacyTokenParam
    & JWTTokenParam
    & LoginCredentialParams;

export function hasLegacyTokenParam (params: Record<string, unknown>): params is LegacyTokenParam {
    return (
        typeof params?.[AppURLSearchParams.token] === 'string'
    );
}

export function hasJWTTokenParam (params: Record<string, unknown>): params is JWTTokenParam {
    return (
        typeof params?.[AppURLSearchParams.jwtToken] === 'string'
    );
}

export function isSessionsResponse (data: Record<string, unknown>): data is SessionsPOSTResponse {
    return (
        typeof data?.jwtToken === 'string' ||
        typeof data?.token === 'string'
    ) && typeof data?.createdAt === 'string';
}
